// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CocktailsRouteImport } from './routes/cocktails'
import { Route as CocktailsMenuRouteImport } from './routes/cocktails-menu'
import { Route as EventsRouteImport } from './routes/events'
import { Route as FoodMenuRouteImport } from './routes/food-menu'
import { Route as GoRouteImport } from './routes/go'
import { Route as KaraokeDublinRouteImport } from './routes/karaoke-dublin'
import { Route as PooltableDublinCitycenterRouteImport } from './routes/pooltable-dublin-citycenter'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as BookingConfirmedReferenceRouteImport } from './routes/booking-confirmed.$reference'
import { Route as EventsIndexRouteImport } from './routes/events.index'
import { Route as EventsSlugRouteImport } from './routes/events.$slug'
import { Route as MenuSlugRouteImport } from './routes/menu.$slug'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminAiRouteImport } from './routes/_authenticated/admin.ai'
import { Route as AuthenticatedAdminAuditLogRouteImport } from './routes/_authenticated/admin.audit-log'
import { Route as AuthenticatedAdminBookingControlRouteImport } from './routes/_authenticated/admin.booking-control'
import { Route as AuthenticatedAdminCalendarRouteImport } from './routes/_authenticated/admin.calendar'
import { Route as AuthenticatedAdminEventsRouteImport } from './routes/_authenticated/admin.events'
import { Route as AuthenticatedAdminFloorPlanRouteImport } from './routes/_authenticated/admin.floor-plan'
import { Route as AuthenticatedAdminGuestsRouteImport } from './routes/_authenticated/admin.guests'
import { Route as AuthenticatedAdminInstagramRouteImport } from './routes/_authenticated/admin.instagram'
import { Route as AuthenticatedAdminKaraokeRouteImport } from './routes/_authenticated/admin.karaoke'
import { Route as AuthenticatedAdminMenuRouteImport } from './routes/_authenticated/admin.menu'
import { Route as AuthenticatedAdminPaymentsRouteImport } from './routes/_authenticated/admin.payments'
import { Route as AuthenticatedAdminReportsRouteImport } from './routes/_authenticated/admin.reports'
import { Route as AuthenticatedAdminReservationsRouteImport } from './routes/_authenticated/admin.reservations'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin.settings'
import { Route as AuthenticatedAdminTeamRouteImport } from './routes/_authenticated/admin.team'
import { Route as AuthenticatedAdminWaitlistRouteImport } from './routes/_authenticated/admin.waitlist'
import { Route as AuthenticatedAdminAiIndexRouteImport } from './routes/_authenticated/admin.ai.index'
import { Route as AuthenticatedAdminAiThreadIdRouteImport } from './routes/_authenticated/admin.ai.$threadId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const CocktailsRoute = CocktailsRouteImport.update({
            id: '/cocktails',path: '/cocktails',getParentRoute: () => rootRouteImport
          })
const CocktailsMenuRoute = CocktailsMenuRouteImport.update({
            id: '/cocktails-menu',path: '/cocktails-menu',getParentRoute: () => rootRouteImport
          })
const EventsRoute = EventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => rootRouteImport
          })
const FoodMenuRoute = FoodMenuRouteImport.update({
            id: '/food-menu',path: '/food-menu',getParentRoute: () => rootRouteImport
          })
const GoRoute = GoRouteImport.update({
            id: '/go',path: '/go',getParentRoute: () => rootRouteImport
          })
const KaraokeDublinRoute = KaraokeDublinRouteImport.update({
            id: '/karaoke-dublin',path: '/karaoke-dublin',getParentRoute: () => rootRouteImport
          })
const PooltableDublinCitycenterRoute = PooltableDublinCitycenterRouteImport.update({
            id: '/pooltable-dublin-citycenter',path: '/pooltable-dublin-citycenter',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const BookingConfirmedReferenceRoute = BookingConfirmedReferenceRouteImport.update({
            id: '/booking-confirmed/$reference',path: '/booking-confirmed/$reference',getParentRoute: () => rootRouteImport
          })
const EventsIndexRoute = EventsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EventsRoute
          })
const EventsSlugRoute = EventsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => EventsRoute
          })
const MenuSlugRoute = MenuSlugRouteImport.update({
            id: '/menu/$slug',path: '/menu/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAiRoute = AuthenticatedAdminAiRouteImport.update({
            id: '/ai',path: '/ai',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAuditLogRoute = AuthenticatedAdminAuditLogRouteImport.update({
            id: '/audit-log',path: '/audit-log',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBookingControlRoute = AuthenticatedAdminBookingControlRouteImport.update({
            id: '/booking-control',path: '/booking-control',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCalendarRoute = AuthenticatedAdminCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEventsRoute = AuthenticatedAdminEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminFloorPlanRoute = AuthenticatedAdminFloorPlanRouteImport.update({
            id: '/floor-plan',path: '/floor-plan',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminGuestsRoute = AuthenticatedAdminGuestsRouteImport.update({
            id: '/guests',path: '/guests',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminInstagramRoute = AuthenticatedAdminInstagramRouteImport.update({
            id: '/instagram',path: '/instagram',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminKaraokeRoute = AuthenticatedAdminKaraokeRouteImport.update({
            id: '/karaoke',path: '/karaoke',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminMenuRoute = AuthenticatedAdminMenuRouteImport.update({
            id: '/menu',path: '/menu',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPaymentsRoute = AuthenticatedAdminPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminReportsRoute = AuthenticatedAdminReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminReservationsRoute = AuthenticatedAdminReservationsRouteImport.update({
            id: '/reservations',path: '/reservations',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSettingsRoute = AuthenticatedAdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTeamRoute = AuthenticatedAdminTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminWaitlistRoute = AuthenticatedAdminWaitlistRouteImport.update({
            id: '/waitlist',path: '/waitlist',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAiIndexRoute = AuthenticatedAdminAiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminAiRoute
          })
const AuthenticatedAdminAiThreadIdRoute = AuthenticatedAdminAiThreadIdRouteImport.update({
            id: '/$threadId',path: '/$threadId',getParentRoute: () => AuthenticatedAdminAiRoute
          })





const AuthenticatedAdminAiRouteChildren = {
  AuthenticatedAdminAiThreadIdRoute: AuthenticatedAdminAiThreadIdRoute,AuthenticatedAdminAiIndexRoute: AuthenticatedAdminAiIndexRoute
}

const AuthenticatedAdminAiRouteWithChildren = AuthenticatedAdminAiRoute._addFileChildren(AuthenticatedAdminAiRouteChildren)



const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAiRoute: AuthenticatedAdminAiRouteWithChildren,AuthenticatedAdminAuditLogRoute: AuthenticatedAdminAuditLogRoute,AuthenticatedAdminBookingControlRoute: AuthenticatedAdminBookingControlRoute,AuthenticatedAdminCalendarRoute: AuthenticatedAdminCalendarRoute,AuthenticatedAdminEventsRoute: AuthenticatedAdminEventsRoute,AuthenticatedAdminFloorPlanRoute: AuthenticatedAdminFloorPlanRoute,AuthenticatedAdminGuestsRoute: AuthenticatedAdminGuestsRoute,AuthenticatedAdminInstagramRoute: AuthenticatedAdminInstagramRoute,AuthenticatedAdminKaraokeRoute: AuthenticatedAdminKaraokeRoute,AuthenticatedAdminMenuRoute: AuthenticatedAdminMenuRoute,AuthenticatedAdminPaymentsRoute: AuthenticatedAdminPaymentsRoute,AuthenticatedAdminReportsRoute: AuthenticatedAdminReportsRoute,AuthenticatedAdminReservationsRoute: AuthenticatedAdminReservationsRoute,AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,AuthenticatedAdminTeamRoute: AuthenticatedAdminTeamRoute,AuthenticatedAdminWaitlistRoute: AuthenticatedAdminWaitlistRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const EventsRouteChildren = {
  EventsSlugRoute: EventsSlugRoute,EventsIndexRoute: EventsIndexRoute
}

const EventsRouteWithChildren = EventsRoute._addFileChildren(EventsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,CocktailsRoute: CocktailsRoute,CocktailsMenuRoute: CocktailsMenuRoute,EventsRoute: EventsRouteWithChildren,FoodMenuRoute: FoodMenuRoute,GoRoute: GoRoute,KaraokeDublinRoute: KaraokeDublinRoute,PooltableDublinCitycenterRoute: PooltableDublinCitycenterRoute,PrivacyRoute: PrivacyRoute,BookingConfirmedReferenceRoute: BookingConfirmedReferenceRoute,MenuSlugRoute: MenuSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)